import React from "react";
import { motion } from "framer-motion";
import { fadeUp, staggerContainer, viewportOnce } from "@/lib/motion";
import { SunArcs } from "@/components/SunArcs";

const STATS = [
  { value: "+29%", label: "notti vendute dopo l'intervento sul pricing" },
  { value: "+158%", label: "ricavi a giugno rispetto allo stesso mese dell'anno precedente" },
];

export const Risultati = () => (
  <section id="risultati" data-testid="section-risultati" className="relative overflow-hidden bg-navy py-24 text-white md:py-32">
    <SunArcs className="pointer-events-none absolute -top-20 left-1/2 w-[900px] max-w-none -translate-x-1/2" rings={8} spin opacity={0.12} />

    <div className="relative mx-auto max-w-7xl px-6 md:px-12">
      <motion.div variants={staggerContainer} initial="hidden" whileInView="show" viewport={viewportOnce} className="max-w-3xl">
        <motion.p variants={fadeUp} className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-gold">
          I risultati
        </motion.p>
        <motion.h2 variants={fadeUp} className="font-display text-4xl font-medium tracking-tight sm:text-5xl">
          I numeri parlano.
        </motion.h2>
        <motion.p variants={fadeUp} className="mt-7 text-base leading-relaxed text-white/70 sm:text-lg">
          Ecco cosa cambia quando si smette di tenere i prezzi fissi e si inizia a lavorare sui dati.
          (Metriche reali, ricostruite in forma anonima.)
        </motion.p>
      </motion.div>

      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2"
      >
        {STATS.map((s, i) => (
          <motion.div
            key={i}
            variants={fadeUp}
            data-testid={`stat-${i}`}
            className={`rounded-2xl p-8 backdrop-blur-sm transition-colors duration-300 ${
              s.slot
                ? "border border-dashed border-white/15 bg-transparent"
                : "border border-white/10 bg-white/[0.04] hover:border-gold/40"
            }`}
          >
            <div className={`font-display font-light tracking-tight ${s.slot ? "text-4xl text-white/30 md:text-5xl" : "text-6xl text-gold md:text-7xl"}`}>
              {s.slot ? "—" : s.value}
            </div>
            <div className="mt-4 text-sm leading-relaxed text-white/70">{s.label}</div>
          </motion.div>
        ))}
      </motion.div>

      <motion.blockquote
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        data-testid="risultati-case"
        className="mt-10 rounded-2xl border border-gold/20 bg-gradient-to-r from-white/[0.06] to-transparent p-8 md:p-10"
      >
        <p className="text-lg italic leading-relaxed text-white/85 md:text-xl">
          Struttura in zona costiera, occupazione già alta ma a prezzo medio compresso. Dopo
          l'intervento su pricing e distribuzione: notti vendute +29% e tariffe rialzate, senza
          abbassare i prezzi nei periodi di picco.
        </p>
      </motion.blockquote>
    </div>
  </section>
);
